var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 20.025L11.5 16.025L12.575 14.95L15.5 17.875L21.475 11.9L22.55 12.975L15.5 20.025ZM21 9.675H19.5V4.5H18V6.75H6V4.5H4.5V19.5H10.775V21H4.5C4.06667 21 3.70833 20.8583 3.425 20.575C3.14167 20.2917 3 19.9333 3 19.5V4.5C3 4.06667 3.14167 3.70833 3.425 3.425C3.70833 3.14167 4.06667 3 4.5 3H9.55C9.66667 2.41667 9.95417 1.9375 10.4125 1.5625C10.8708 1.1875 11.4 1 12 1C12.6 1 13.1292 1.1875 13.5875 1.5625C14.0458 1.9375 14.3333 2.41667 14.45 3H19.5C19.9333 3 20.2917 3.14167 20.575 3.425C20.8583 3.70833 21 4.06667 21 4.5V9.675ZM12 4.5C12.2833 4.5 12.5208 4.40417 12.7125 4.2125C12.9042 4.02083 13 3.78333 13 3.5C13 3.21667 12.9042 2.97917 12.7125 2.7875C12.5208 2.59583 12.2833 2.5 12 2.5C11.7167 2.5 11.4792 2.59583 11.2875 2.7875C11.0958 2.97917 11 3.21667 11 3.5C11 3.78333 11.0958 4.02083 11.2875 4.2125C11.4792 4.40417 11.7167 4.5 12 4.5Z",
    fill: "#132353"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.c0761c5c1ccee57b8ac1d48a554eb35a.svg";
export { ForwardRef as ReactComponent };